import { ref, watch } from "vue";

/**
 * One-shot signal: resolves once the projects page has mounted and its project list has settled.
 * The anchored welcome tour's last new-user step anchors to the "Add your first project" empty
 * state, which only exists once ProjectList's fetch has resolved — starting the tour before then
 * would skip the one step that matters most.
 */
const isReady = ref(false);

export function markProjectsPageReady(): void {
  isReady.value = true;
}

export function resetProjectsPageReady(): void {
  isReady.value = false;
}

export function waitForProjectsPageReady(): Promise<void> {
  if (isReady.value) return Promise.resolve();

  return new Promise<void>((resolve) => {
    const stop = watch(isReady, (ready) => {
      if (ready) {
        stop();
        resolve();
      }
    });
  });
}
